import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
/** Frosted panel: 28px corners, rises in on first show (D88). */
export function Card({ className, ...rest }) {
    return _jsx("div", { className: cn("glass animate-rise rounded-card p-4 sm:p-6", className), ...rest });
}
export function CardTitle({ className, ...rest }) {
    return _jsx("h2", { className: cn("font-heading text-lg font-semibold text-fg", className), ...rest });
}
//# sourceMappingURL=Card.js.map